import { PaginationPayload, PaginationResponse } from "types";

import { EncounterListItem } from "modules/in-process/types";
import { axiosPatientInstance } from "config";
import { useInfiniteQuery } from "react-query";

type UseInProcessEncounterProps = PaginationPayload & {
  patientStatus?: string;
  search?: string;
  searchOpenCharts?: boolean;
  searchDisposition?: boolean;
  assignation?: InProcessAssignOptions;
};

type InProcessSortOptions = "room" | "createdAt" | "dispositionTime";

type InProcessAssignOptions = "All" | "AssignedToMe" | "Unassigned";

type UseInProcessEncounterResponse = PaginationResponse<EncounterListItem>;

function useInProcessEncounters(props: UseInProcessEncounterProps) {
  const {
    size = 10,
    page = 1,
    search,
    patientStatus,
    sort = "room",
    descending = true,
    assignation = "All",
    searchOpenCharts = false,
    searchDisposition = false,
  } = props;

  return useInfiniteQuery(
    [
      "inProcessEncounterList",
      {
        search,
        patientStatus,
        sort,
        descending,
        assignation,
        searchOpenCharts,
        searchDisposition,
      },
    ],
    ({ pageParam = page }) =>
      axiosPatientInstance.get<UseInProcessEncounterResponse>("v1/InProcess", {
        params: {
          pageSize: size,
          page: pageParam,
          search,
          patientStatus,
          orderBy: sort || "createdAt",
          sortDesc: descending || false,
          assignation,
          searchOpenCharts,
          searchDisposition,
        },
      }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.data.currentPage < lastPage.data.totalPages) {
          return lastPage.data.currentPage + 1;
        }
        return undefined;
      },
      getPreviousPageParam: (firstPage) => {
        if (firstPage.data.currentPage > 1) {
          return firstPage.data.currentPage - 1;
        }
        return undefined;
      },
    }
  );
}

export type {
  UseInProcessEncounterResponse,
  InProcessSortOptions,
  InProcessAssignOptions,
};
export { useInProcessEncounters };
